<template>
  <div>我是学生端</div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/setUp/studentSetUp.vue